<template>
  <div>
     <header>
          <div class="headerOne">
              <img src="../../assets/images/returnOne.png" @click="$router.go(-1)">
              <span class="buss">选择出生日期</span>
          </div>
      </header>
      <button >选择</button>
       <!-- <el-button type="text" @click="open">点击打开 Message Box</el-button> -->

   

  </div>
</template>
<script>



    export default{
        data(){
            return{
                pickerValue:"",
            }
        },
        
        // created:function(){
        //    this.$refs.picker.open();
        // },
        methods:{
            
           }
        
        //  valiBrand(data) {
        //     let date = moment(data).format("YYYY-MM-DD");
        //     this.carsInfo.licenseTime = date;
        //     },
        
        
    }
</script>
<style>
header{
    height:1rem;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.20);
    position: relative;
}
 .headerOne{
     font-size: 0;  
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .headerOne .buss{
      display: inline-block;
      font-size: 0.35rem;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
  }
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/components/change/birthday.vue